import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
    const navigate = useNavigate();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = match[1];

        (async () => {
            try {
                const r = await api.post("/auth/session", { session_id: sessionId });
                // store as fallback for cross-site cookie issues
                // backend returns no token in body intentionally for security; use cookie path
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: r.data } });
            } catch (e) {
                console.error("Auth callback failed", e);
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
                <div className="overline mb-2">Autenticando</div>
                <div className="font-display text-2xl font-bold">Estableciendo sesión…</div>
            </div>
        </div>
    );
}
